<template>
  <div class="main-container">
    <Header />

    <HeroOne :sliderData="getSlideShows" />

    <ServiceSlider />

    <!-- <FunFact /> -->

    <AboutSection :data="pageData" />

    <!-- <LatestProject /> -->

    <!-- <TeamJob /> -->

    <!-- <Testimonial /> -->

    <BlogSection addClass="grey-bg" />

    <!-- <BrandCarousel /> -->

    <Footer />

    <OffCanvasMobileMenu />

    <!-- back to top start -->
    <back-to-top class="scroll-top" bottom="60px">
      <i class="ion-android-arrow-up"></i>
    </back-to-top>
    <!-- back to top end -->
  </div>
</template>

<script>
import Header from "@/components/Header"
import HeroOne from "../components/sections/HeroOne"
import ServiceSlider from "../components/sections/ServiceSlider"
import FunFact from "../components/FunFact"
import AboutSection from "../components/sections/AboutSection"
import LatestProject from "../components/sections/LatestProject"
import TeamJob from "../components/sections/TeamJob"
import Testimonial from "../components/Testimonial"
import BlogSection from "../components/sections/BlogSection"
import BrandCarousel from "../components/BrandCarousel"
import Footer from "../components/Footer"
import OffCanvasMobileMenu from "@/components/OffCanvasMobileMenu"

import data from "../data/slider.json"
import { slideShowStore } from "@/store/Modules/slideShow.js"
import { mapState } from "pinia"
import { mapStores } from "pinia"
import { mapActions } from "pinia"
import { PageService } from "@/store/services/page.service.js"

export default {
  data() {
    return {
      data,
      pageData: {},
      metaTitle: "",
      metaDescripton: "",
      metaKeywords: "",
    }
  },
  components: {
    Header,
    HeroOne,
    ServiceSlider,
    FunFact,
    AboutSection,
    LatestProject,
    TeamJob,
    Testimonial,
    BlogSection,
    BrandCarousel,
    Footer,
    OffCanvasMobileMenu,
  },
  // metaInfo: {
  //   title: "کاسترو - خانه 1",
  //   htmlAttrs: {
  //     lang: "fa",
  //     amp: true,
  //   },
  // },
  metaInfo() {
    return {
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.metaDescripton,
        },
        {
          vmid: "title",
          name: "title",
          content: this.metaTitle,
        },
      ],
    }
  },
  mounted() {
    this.getSlideShowsAction()

    this.pageData = PageService.showByTitle("home").then(({ data }) => {
      this.pageData = data
      this.metaTitle = data.extras.meta_title
      this.metaDescripton = data.extras.meta_description
      // this.metaKeywords = data.extras.metaKeywords
    })
  },
  computed: {
    ...mapState(slideShowStore, ["getSlideShows"]),
  },
  methods: { ...mapActions(slideShowStore, ["getSlideShowsAction"]) },
}
</script>
